import { Card, CardContent, CardActions, Typography, Button } from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { useTranslation } from 'react-i18next';
import { IReportList } from 'types/IComponentTypes';

/**
 * Props for the {@link CardLayout} component.
 */
interface ICardLayoutProps {
  /** The report list item data to display in the card. */
  data: IReportList;
  /** Callback invoked when the download button is clicked, receiving the report's download function name. */
  onDownload: (downloadFunctionName: string) => void;
}

/**
 * Renders a Material UI card for a single report entry, displaying its name
 * and a download button that triggers the provided {@link ICardLayoutProps.onDownload} callback.
 *
 * @param props - {@link ICardLayoutProps}
 */
export const CardLayout = ({ data, onDownload }: ICardLayoutProps) => {
  const { t } = useTranslation();

  return (
    <Card
      data-testid={`report-card-${data.id}`}
      className="report-card"
      sx={{
        width: 275,
        m: 1,
      }}
    >
      <CardContent style={{ padding: '8px' }}>
        <Typography variant="h6" component="div" gutterBottom className="report-card-title">
          {t(data.name)}
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          data-testid={`download-btn-${data.id}`}
          variant="contained"
          startIcon={<SystemUpdateAltIcon />}
          onClick={() => onDownload(data.downloadFunctionName)}
          className="text-capitalize report-card-download-btn"
          size="small"
        >
          {t('button.download')}
        </Button>
      </CardActions>
    </Card>
  );
};
